import type * as Y from 'yjs';

export type BasicYArray<T = unknown> = Pick<
  Y.Array<T>,
  | 'doc'
  | 'get'
  | 'length'
  | 'toArray'
  | 'insert'
  | 'push'
  | 'unshift'
  | 'delete'
  | 'observe'
  | 'observeDeep'
  | 'unobserve'
  | 'unobserveDeep'
  | 'slice'
> & {
  forEach(f: (arg0: T, arg1: number, arg2: BasicYArray<T>) => void): void;
};

export type BasicYMap<T = unknown> = Pick<
  Y.Map<T>,
  | 'doc'
  | 'get'
  | 'set'
  | 'has'
  | 'delete'
  | 'values'
  | 'entries'
  | 'keys'
  | 'forEach'
  | 'observe'
  | 'observeDeep'
  | 'unobserve'
  | 'unobserveDeep'
>;

/**
 * A type that acts as a wrapper around a YJS type. The unmap() method should return the
 * underlying native YJS object, which can be used when attaching the element to a parent.
 */
export interface WrappedYType {
  unwrap(): Y.AbstractType<any> | undefined;
}

export function isWrappedYType(obj: unknown): obj is WrappedYType {
  return (
    !!obj &&
    typeof obj === 'object' &&
    'unwrap' in obj &&
    typeof obj.unwrap === 'function'
  );
}

export interface DisposableElement {
  dispose(): void;
}

export function isDisposableElement(obj: unknown): obj is DisposableElement {
  return (
    !!obj &&
    typeof obj === 'object' &&
    'dispose' in obj &&
    typeof obj.dispose === 'function'
  );
}
